(() => {
  if (!['/urun.html', '/urun'].includes(window.location.pathname.toLowerCase())) return;
  const code = (new URLSearchParams(window.location.search).get('p') || '')
    .toLocaleUpperCase('tr-TR')
    .replace(/[^A-Z0-9]/g, '');
  const products = {
  "55265": "/products/termos-bardak-450-ml",
  "55270": "/products/ccift-duvarli-kupa-celik-bardak-450-ml",
  "55347": "/products/termos-400-ml",
  "55356": "/products/kilitli-kapak-dereceli-termos-350-ml",
  "55515": "/products/tyeso-daily-need-termos-1050-ml",
  "55563": "/products/kupa-celik-bardak-450-ml",
  "55590": "/products/ccift-duvarli-vakumlu-termos-bardak-540-ml",
  "55595": "/products/ccift-duvarli-vakumlu-termos-bardak-450-ml",
  "55860": "/products/celik-termos-500-ml",
  "55865": "/products/termos-750-ml",
  "55510SY": "/products/tyeso-dailyneed-termos-siyah-600-ml",
  "55510GR": "/products/tyeso-dailyneed-termos-gri-600-ml",
  "55510BY": "/products/tyeso-dailyneed-termos-beyaz-600-ml",
  "55245SY": "/products/smart-termos-450-ml-siyah",
  "55245LC": "/products/smart-termos-450-ml-lacivert",
  "55245BY": "/products/smart-termos-450-ml-beyaz",
  "55957SY": "/products/termos-bardak-500-ml-siyah",
  "55957GM": "/products/termos-bardak-500-ml-gumus",
  "55505SY": "/products/termos-bardak-siyah-550-ml",
  "55505LC": "/products/termos-bardak-lacivert-550-ml",
  "55505GR": "/products/termos-bardak-gri-550-ml",
  "55519SY": "/products/dereceli-kupa-celik-bardak-380-ml-siyah",
  "55519BY": "/products/dereceli-kupa-celik-bardak-380-ml-beyaz",
  "55359SY": "/products/kilitli-kapak-termos-700-ml-siyah",
  "55359LC": "/products/kilitli-kapak-termos-700-ml-lacivert",
  "55359GM": "/products/kilitli-kapak-termos-700-ml-gumus",
  "55359BY": "/products/kilitli-kapak-termos-700-ml-beyaz",
  "55622SY": "/products/kupa-celik-bardak-400-ml-siyah",
  "55622KR": "/products/kupa-celik-bardak-400-ml-kirmizi",
  "55622KH": "/products/kupa-celik-bardak-400-ml-kahve",
  "55622BY": "/products/kupa-celik-bardak-400-ml-beyaz",
  "55370SY": "/products/kupa-celik-bardak-240-ml-mat-siyah",
  "55370BY": "/products/kupa-celik-bardak-240-ml-mat-beyaz",
  "55370GM": "/products/kupa-celik-bardak-240-ml-gumus",
  "55370LC": "/products/kupa-celik-bardak-240-ml-mat-lacivert",
  "55370KR": "/products/kupa-celik-bardak-240-ml-mat-kirmizi",
  "55392GM": "/products/sise-termos-500-ml-gumus",
  "55392BY": "/products/sise-termos-500-ml-beyaz",
  "55532BY": "/products/termos-matara-500-ml-beyaz",
  "55532LC": "/products/termos-matara-500-ml-lacivert",
  "55532GM": "/products/termos-matara-500-ml-gumus",
  "55532SY": "/products/termos-matara-500-ml-siyah",
  "55532KR": "/products/termos-matara-500-ml-kirmizi",
  "55341YS": "/products/bardakli-termos-1-450-ml-yesil",
  "55341SY": "/products/bardakli-termos-1-450-ml-siyah",
  "55357SY": "/products/termos-1-300-ml-siyah",
  "55357GM": "/products/termos-1-300-ml-gumus",
  "55526YS": "/products/termos-set-500-ml-yesil",
  "55526SY": "/products/termos-set-500-ml-siyah",
  "55526PM": "/products/termos-set-500-ml-pembe",
  "55554SY": "/products/french-press-termos-500-ml-siyah",
  "55554GM": "/products/french-press-termos-500-ml-gumus",
  "55554BY": "/products/french-press-termos-500-ml-beyaz",
  "55520YS": "/products/kupa-celik-bardak-yesil-300-ml",
  "55520TR": "/products/kupa-celik-bardak-turuncu-300-ml",
  "55520SY": "/products/kupa-celik-bardak-siyah-300-ml",
  "55520MV": "/products/kupa-celik-bardak-mavi-300-ml",
  "55520LC": "/products/kupa-celik-bardak-lacivert-300-ml",
  "55520KR": "/products/kupa-celik-bardak-kirmizi-300-ml",
  "55520AL": "/products/kupa-celik-bardak-altin-300-ml",
  "55351SY": "/products/termos-440-ml-siyah",
  "55351BY": "/products/termos-440-ml-beyaz",
  "55343SY": "/products/termos-1-500-ml-siyah",
  "55343GM": "/products/termos-1-500-ml-gumus"
};
  window.location.replace(products[code] || '/collections/all');
})();
